globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalDeleteDomainRequest = (function(superClass)
{
    utils.extend(ModalDeleteDomainRequest, superClass);

    function ModalDeleteDomainRequest($html) {
      return ModalDeleteDomainRequest.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalDeleteDomainRequest.prototype, {
      init: function() {
        this.$html.find('.styled').uniform({
          radioClass: 'choice'
        });

        ModalDeleteDomainRequest.__super__.init.apply(this, arguments);
      }
    });

    return ModalDeleteDomainRequest;
})(backoffice.ModalMain);
